import React, { useEffect, useState } from "react";

import { IValidationPinCode, TRecoverType } from "./validationPinCode.d.ts";
import InputPinCode from "../welcome/InputPinCode";
import Recaptcha from "../Recaptcha";

import {
	ButtonContainer,
	Col,
	Container,
	ContainerPinCode,
	Content,
	ContentButton,
	Timer,
	MessageError,
	Subtitle,
	TextResend,
	Title,
} from "./styles";

import whatsAppIcon from "../../assets/WhatsApp.svg";
import smsIcon from "../../assets/SMS.svg";

import { convertSecondsInMinutes } from "../../utils";

import { Button } from "../../shared/components";

/**
 *
 * @param {IValidationPinCode} param
 */
const ValidationPinCode = ({
	title,
	subtitle,
	error,
	messageError,
	resendType: type,
	seconds = 30,
	setTokenRecaptcha,
	onSubmit,
	onChange,
	onResendCode,
}) => {
	const [timeResend, setTimeResend] = useState(`00:${seconds}`);
	const [isSendCode, setIsSendCode] = useState(true);
	const [showRecaptcha, setShowRecaptcha] = useState(false);
	const [isValidRecaptcha, setIsValidShowRecaptcha] = useState(false);
	const [token, setToken] = useState({});
	const [resendType, setResendType] = useState(type);

	useEffect(() => {
		resendCodeInterval();
	}, []);

	useEffect(() => {
		if (!isValidRecaptcha && !Object.keys(token).length) return;

		resendCodeInterval();
		handleState();
	}, [isValidRecaptcha]);

	function resendCodeInterval() {
		let controlTime = seconds;

		const interval = setInterval(() => {
			setTimeResend(convertSecondsInMinutes(controlTime--));

			if (controlTime < 0) {
				clearInterval(interval);
				setIsSendCode(false);
			}
		}, 1000);
	}

	/**
	 *
	 * @param {TRecoverType} param
	 */
	function resendCode(param) {
		setShowRecaptcha(true);
		setResendType(param);
	}

	function handleState() {
		onResendCode(resendType);
		setTokenRecaptcha(token);
		setIsSendCode(true);
		setShowRecaptcha(false);
		setIsValidShowRecaptcha(false);
		setToken({});
	}

	return (
		<Container>
			<Content>
				<Col>
					<Title dangerouslySetInnerHTML={{ __html: title }} />
					<Subtitle dangerouslySetInnerHTML={{ __html: subtitle }} />
				</Col>
				<ContainerPinCode>
					<InputPinCode
						onSubmit={(pin) => onSubmit(pin)}
						error={error}
						newLayout={true}
						onChangePin={Boolean(onChange) ? onChange : () => {}}
					/>
					{error && (
						<MessageError>
							{messageError
								? messageError
								: "Código inválido, revise e tente novamente"}
						</MessageError>
					)}
				</ContainerPinCode>

				{isSendCode ? (
					<Timer>
						<span>
							Receba um novo código em{" "}
							<strong>{timeResend}</strong>
						</span>
					</Timer>
				) : (
					<ButtonContainer>
						{["phone_mobile", "whatsapp"].includes(resendType) && (
							<TextResend>Reenviar código por:</TextResend>
						)}

						{["phone_mobile", "whatsapp"].includes(resendType) ? (
							<ContentButton>
								<Button
									btnType="outline"
									onClick={() => {
										resendCode(
											"phone_mobile"
										);
									}}
								>
									<img
										src={smsIcon}
										alt="SMS icone"
									/>
									SMS
								</Button>

								<Button
									btnType="outline"
									onClick={() => {
										resendCode(
											"whatsapp"
										);
									}}
								>
									<img
										src={whatsAppIcon}
										alt="WhatsApp icone"
									/>
									WhatsApp
								</Button>
							</ContentButton>
						) : (
							<ContentButton centered>
								<Button
									title="Reenviar código"
									btnType="fill"
									onClick={() => {
										resendCode("email");
									}}
								/>
							</ContentButton>
						)}
					</ButtonContainer>
				)}

				{showRecaptcha && (
					<Recaptcha isValid={setIsValidShowRecaptcha} token={setToken} />
				)}
			</Content>
		</Container>
	);
};

export default ValidationPinCode;
